import { render, staticRenderFns } from "./BackgroundLine.vue?vue&type=template&id=35c167de&scoped=true&"
import script from "./BackgroundLine.vue?vue&type=script&lang=js&"
export * from "./BackgroundLine.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundLine.vue?vue&type=style&index=0&id=35c167de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c167de",
  null
  
)

export default component.exports